import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeEvery } from 'redux-saga/effects';
import menuBookEditorService from './menuBookEditorService';
import { menuBookEditorActions } from './menuBookEditorSlice';
import { Genre, MenuBookEditorGetAllPayload, SubMenu } from './models';

function* getData(action: PayloadAction<MenuBookEditorGetAllPayload>) {
  try {
    const response: CommonResponse<Genre[]> = yield call(menuBookEditorService.getAll, action.payload);
    yield put(menuBookEditorActions.fetchDataSuccess(response.data));
  } catch (e) {
    yield put(menuBookEditorActions.fetchDataFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* fetchSubMenuGroupData(action: PayloadAction<{ subMenuGroupId: number; dataDate: Date }>) {
  try {
    const response: CommonResponse<SubMenu[]> = yield call(
      menuBookEditorService.getSubMenuGroupData,
      action.payload.subMenuGroupId,
      action.payload.dataDate
    );
    yield put(
      menuBookEditorActions.fetchSubMenuGroupDataSuccess({
        subMenuGroupId: action.payload.subMenuGroupId,
        subMenus: response.data,
      })
    );
  } catch (e) {
    yield put(menuBookEditorActions.fetchSubMenuGroupDataFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* menuBookEditorSaga() {
  yield takeEvery(menuBookEditorActions.fetchData.type, getData);
  yield takeEvery(menuBookEditorActions.fetchSubMenuGroupData.type, fetchSubMenuGroupData);
}
